import React from "react";
import PropTypes from "prop-types";
import {GiftCardAPI} from "../../../../../api/GiftCard/GiftCardAPI";
import {swalError, swalLoading, swalSuccess} from "../../../../../helpers/SweetAlertWrapper";

export class RedeemGiftCardView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            giftCard: null,
            loading: false,
        };
        this.backgroundStyle = {
            background: "#f5f8fb"
        }
        this.messageContainerStyle = {
            background: "rgba(38,48,105,0.14)",
            padding: "14px 16px",
            borderRadius: "10px",
            marginTop: "18px",
            color: "#2d2d2d",
            fontSize: "0.95rem",
            borderLeft: "4px solid #263069"
        }
    }

    componentDidMount() {
        this.setState({loading: true});
        GiftCardAPI.User.getGiftCardToRedeem(this.props.secretKey)
            .then(giftCard => {
                this.setState({giftCard: giftCard, loading: false})
            })
            .catch(error => {
                this.setState({loading: false});
                swalError(error).then(_=>this.props.onDismiss());
            });
    }

    onRedeemedButtonClick = () => {
        swalLoading("Stiamo riscattando la tua gift card...")
        GiftCardAPI.User.redeem(this.props.secretKey)
            .then(msg => swalSuccess(msg).then(this.props.onDismiss()))
            .catch(msg => swalError(msg));
    }

    render() {
        const {loading, giftCard} = this.state;

        if (loading) {
            return (
                <div className={"py-5 text-center"} style={{backgroundColor: "white"}}>
                    <div className="spinner-border text-primary" role="status"/>
                </div>
            );
        }

        if (!giftCard) return (
            <div className={"py-5 text-center"} style={{backgroundColor: "white"}}>
                Non abbiamo identificato la gift card che cercavi
            </div>
        );

        const giver = giftCard.giver_user;
        const shop = giftCard.shop;
        const operation = giftCard.operation;
        const card = giftCard.gift_card;

        const headerStyle = {
            width: "100%",
            height: "240px",
            display: "flex",
            alignItems: "flex-end",
            padding: "24px",
            color: "white",
            backgroundImage: card?.image_url
                ? `linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,0.85) 100%), url(${card.image_url})`
                : "linear-gradient(120deg, #007bff 0%, #00b4ff 100%)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            borderRadius: "14px 14px 0 0"
        };

        return (
            <div style={this.backgroundStyle}>
                <div className="container py-5">
                    <div className="shadow-sm border-0 card card-body p-0">

                        {/* Header */}
                        <div style={headerStyle}>
                            <h4 className="font-weight-bold">
                                🎁 Hai ricevuto un regalo!
                            </h4>
                        </div>

                        {/* Content */}
                        <div className={"p-4"}>
                            <p className={"mt-3"}>
                                <b>{giver.nome} {giver.cognome}</b> ti ha inviato una Gift Card
                                del valore di&nbsp;
                                <span className="text-primary">
                                    {card.saldo_iniziale}€
                                </span>&nbsp;
                                per <b>{shop.nome}</b>
                            </p>

                            {operation.gift_message && (
                                <div style={this.messageContainerStyle}>
                                    <span>💬 Messaggio da {giver.nome}:</span>
                                    <br/>
                                    <i>{operation.gift_message}</i>
                                </div>
                            )}

                            {/* HTML Description */}
                            <div
                                className="mt-4"
                                style={{fontSize: "0.97rem", lineHeight: "1.6", color: "#555"}}
                                dangerouslySetInnerHTML={{__html: card.user_friendly_description}}
                            />

                            {/* Redeem Button */}
                            <button
                                className="btn btn-primary btn-lg btn-block mt-4"
                                onClick={this.onRedeemedButtonClick}
                            >
                                Riscatta Gift Card
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RedeemGiftCardView.propTypes = {
    secretKey: PropTypes.string.isRequired,
    onDismiss: PropTypes.func.isRequired,
};